import React, { useState } from 'react';
import { Modal, notification, Space, Spin, Upload } from 'antd';
import firebase from 'firebase';
import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const DocumentUploader = ({ disabledAdd, maxImageSize, storageFolder, fileList, setFileList, multiple }) => {
  const [uploadInProgress, setUploadInProgress] = useState(false);

  const firebaseRef = firebase.storage()
    .ref(window.location.hostname.split('.')[0] + '/' + storageFolder);

  const onChange = (e) => {
    // 
  };

  const customUploadRequest = (e) => {
    if (e.file) {
      setUploadInProgress(true);
      firebaseRef.child(e.file.name).put(e.file, { cacheControl: 'public, max-age=86400' })
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            setFileList(prev => [...prev, {
              uid: e.file.uid,
              name: e.file.name,
              url: downloadURL,
            }]);
            setUploadInProgress(false);
          }).catch(error => {
            setUploadInProgress(false);
            notification['error']({
              message: 'Error',
              description:
                'File could not be uploaded.',
            });
          });
        });
    }
  };

  const onRemove = (file) => {
    firebaseRef.child(file.name)
      .delete()
      .then(() => {
        notification['info']({
          message: 'Info',
          description:
            'File deleted.',
        });
        const tempFileList = [...fileList];
        const filtered = tempFileList
          .filter(f => !(f.uid === file.uid && f.name === file.name));
        setFileList(filtered);
      }).catch(error => {
      notification['error']({
        message: 'Error',
        description:
          'File could not be deleted.',
      });
    });
  };

  const onDownload = (e) => {
    // 
  };

  const onDrop = (e) => {
    // 
  };

  return (
    <div>
      <Dragger
        fileList={fileList}
        onChange={onChange}
        customRequest={customUploadRequest}
        onRemove={onRemove}
        onDownload={onDownload}
        multiple={multiple}
        disabled={disabledAdd || fileList.length >= maxImageSize}
        onDrop={onDrop}
        showUploadList={{
          showRemoveIcon: !disabledAdd,
        }}
        maxCount={maxImageSize}
      >
        <p className="ant-upload-drag-icon">
          {uploadInProgress ?
            (<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin/>}/>)
            : (<InboxOutlined />)}
        </p>
        <p className="ant-upload-text">Click or drag files to this area to upload</p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload.
        </p>
      </Dragger>
    </div>
  );
};

export default DocumentUploader;
